import React, { Component } from "react";
import "./style.css";
import Box from "components/UI/Box";

class AuthContainer extends Component {
  render() {
    return (
      <div className="div__AuthContainer">
        <div style={{ width: "40vw" }}>
          <img
            src={require("assets/images/logo-dark2.png")}
            width="50%"
            alt="Logo"
          />
          <h1 className="h1__AuthContainer">Administrator</h1>
          <Box outline>{this.props.children}</Box>
        </div>
      </div>
    );
  }
}

export default AuthContainer;
